// 3rd party imports
import * as React from 'react';
import { inject, observer } from 'mobx-react';

// bernie
import { AnalyticsStore, ContextStore, RouteStore } from 'bernie-core';

// shared-ui
import { ILocalization, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// mobx
import { Program, ProgramRelationship, UserInfo } from 'models';
import { ProgramStore, UserAuthStore } from 'stores';

// ui
import { UitkCardPlaceholder } from 'uitk-react-cards';
import { UitkHeading } from 'uitk-react-text';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

// components
import { ProgramCard } from './program-card/program-card';

interface ProgramsProps {
  analytics?: AnalyticsStore;
  context?: ContextStore;
  l10n?: ILocalization;
  programs?: ProgramStore;
  routeStore?: RouteStore;
  userAuth?: UserAuthStore;
  userInfo?: UserInfo;
  userPrograms?: ProgramRelationship[];
}

interface ProgramsState {
  programs: Program[];
}

@withLocalization
@inject('analytics', 'context', 'programs', 'routeStore', 'userAuth')
@observer
export class Programs extends React.Component<ProgramsProps, ProgramsState> {
  public constructor(props) {
    super(props);

    this.state = {
      programs: [],
    };
  }

  public componentDidMount() {
    this.props.programs.getPrograms().then((data) => {
      const forcedLive = this.props.programs.forcedLive;
      if (forcedLive) {
        const index = data.findIndex((program) => program.name === forcedLive);
        if (index >= 0) {
          data[index].live = true;
        }
      }
      this.setState({
        programs: data,
      });
    });
  }

  private renderProgramCards() {
    const { analytics, context, l10n, routeStore, userAuth, userInfo } = this.props;
    const userPrograms = userAuth.userProgramRelationships;

    const { programs } = this.state;

    let partnerId = null;
    let camref = null;
    let programStatus = null;

    const userId = userInfo && userInfo.email ? userInfo.email : null;

    return programs.map((program) => {
      if (userPrograms && userPrograms.body.filter) {
        const candidateUserPrograms = userPrograms.body.filter((userProgram) => {
          return (
            userProgram.id.userId === userId &&
            userProgram.id.brand === program.brand &&
            userProgram.id.posa === program.posa
          );
        });

        if (candidateUserPrograms.length) {
          const userProgram = candidateUserPrograms[0];
          partnerId = userProgram.partnerIdentity.partnerId;
          camref = userProgram.programReference;
          programStatus = userProgram.affiliatePartnership.partnershipStatus;
        } else {
          partnerId = null;
          programStatus = null;
        }
      }

      return (
        <UitkLayoutGridItem key={program.name}>
          <ProgramCard
            analytics={analytics}
            context={context}
            l10n={l10n}
            program={program}
            partnerId={partnerId}
            camref={camref}
            programStatus={programStatus}
            routeStore={routeStore}
            user={userInfo}
            userAuth={userAuth}
          />
        </UitkLayoutGridItem>
      );
    });
  }

  public render() {
    const { programs } = this.state;

    return (
      <UitkSpacing className="container" padding={{ block: 'twelve' }}>
        <main>
          <UitkHeading tag="h1" size={3}>
            <LocalizedText message="programs.title" />
          </UitkHeading>
          <UitkSpacing padding={{ blockstart: 'six' }}>
            <UitkLayoutGrid
              columns={{ small: 1, medium: 2, large: 3 }}
              rows={{ small: 4, medium: 2, large: 1 }}
              space="four"
            >
              {programs.length === 0 &&
                [...Array(9)].map((val, index) => (
                  <div key={index}>
                    <UitkCardPlaceholder aspectRatio="r1-1" />
                  </div>
                ))}
              {this.renderProgramCards()}
            </UitkLayoutGrid>
          </UitkSpacing>
        </main>
      </UitkSpacing>
    );
  }
}
